type TailwindScalePrefix = "size-" | "w-" | "h-" | "gap-";

function extractTailwindValue(token: string, prefixes: TailwindScalePrefix[]): string | null {
  const left = token.indexOf("[");
  if (left !== -1) {
    const right = token.indexOf("]");
    if (right !== -1) return token.slice(left + 1, right);
  }

  for (const prefix of prefixes) {
    if (token.startsWith(prefix)) {
      const raw = parseFloat(token.slice(prefix.length));
      if (!Number.isNaN(raw)) return raw.toString();
    }
  }

  return null;
}

function twScaleToPixels(
  token: string,
  prefixes: TailwindScalePrefix[],
  multiplier = 4
): string | null {
  const raw = extractTailwindValue(token, prefixes);
  if (!raw) return null;
  const num = parseFloat(raw);
  return Number.isNaN(num) ? raw : `${num * multiplier}px`;
}

export const tailwindSizeToPixels = (token: string, multiplier = 4) =>
  twScaleToPixels(token, ["size-", "w-", "h-"], multiplier);

export const tailwindGapToPixels = (token: string, multiplier = 4) =>
  twScaleToPixels(token, ["gap-"], multiplier);
